import React, { useState } from "react";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
// import { Route, Routes } from "react-router-dom";
import Resume from "./Pages/Resume";
import Projects from "./Pages/Projects";
import Topnavbar from "./Components/Topnavbar";
// import Hiddenprojectinfo from "./Components/Hiddenprojectinfo";
import Contact from "./Pages/Contact";

function App() {
  const [togglemenu, settogglemenu] = useState(true); 
  return (
    <div className="overflow-x-hidden">
      <Topnavbar togglemenu={togglemenu} settogglemenu={settogglemenu}/>
    <div className="flex items-center justify-evenly">
      <Navbar/>
      <Home/>
    </div>
    <About/>
    <Resume/>
    <Projects/>
    <Contact/>
    </div>
  );
}

export default App;
